import { differenceInYears } from 'date-fns';

/**
 * Detects the specific DOB-edit transition that fires useBoosterSeatAutoCheck's
 * silent Car Seat -> Booster Seat swap: the rider's age moving from 9 or older
 * down to exactly 7 or 8. Age 6 is intentionally excluded — aging into 6 triggers
 * useCarSeatAutoCheck to *add* Car Seat instead, which isn't a swap worth flagging.
 */
export const didAgeIntoBoosterRange = (
  previousDateOfBirth: Date | string | null | undefined,
  submittedDateOfBirth: Date | string | null | undefined
): boolean => {
  if (!previousDateOfBirth || !submittedDateOfBirth) {
    return false;
  }

  const previousAge = differenceInYears(Date.now(), new Date(previousDateOfBirth));
  const newAge = differenceInYears(Date.now(), new Date(submittedDateOfBirth));

  return previousAge >= 9 && (newAge === 7 || newAge === 8);
};
